import React from "react";
import { ClockIcon, MailIcon, MapPinIcon, NavigationIcon, PhoneIcon } from "lucide-react";
import { useLanguage } from "../contexts/LanguageContext";
import { business } from "../data/business";
import { ui } from "../data/ui";
import { Reveal } from "./Reveal";
export function LocationMap() {
  const {
    t
  } = useLanguage();
  return <Reveal className="mt-16 border-t border-white/10 pt-14" data-id="element-262" data-mp="1b03htv2ci0s4">
      <div className="grid overflow-hidden border border-white/10 bg-charcoal lg:grid-cols-3" data-id="element-263" data-mp="1yp4kf1ohyhph">
        <div className="relative h-[300px] md:h-[350px] lg:col-span-2 lg:h-[420px]" data-id="element-264" data-mp="23oqwh7sl9rwp">
          <iframe src={business.mapEmbedUrl} title={t(ui.contact.mapTitle)} loading="lazy" allowFullScreen referrerPolicy="no-referrer-when-downgrade" className="absolute inset-0 h-full w-full border-0 [filter:grayscale(0.4)_invert(0.9)_hue-rotate(180deg)_contrast(0.9)]" data-id="element-265" data-mp="1pxcft7m5m2st" />
        </div>

        <div className="flex flex-col p-6 sm:p-8" data-id="element-266" data-mp="2mh352c9u5pfa">
          <h3 className="font-display text-2xl font-bold uppercase text-white" data-id="element-267" data-mp="21xxjc3lmzb3h">{t(ui.contact.findUs)}</h3>
          <span className="mt-4 block h-px w-12 bg-gold" aria-hidden="true" data-id="element-268" data-mp="1wyufgmhe7ax3" />

          <address className="mt-6 space-y-5 not-italic text-[15px] text-white/90" data-id="element-269" data-mp="2bn77579g67ls">
            <p className="flex gap-3" data-id="element-270" data-mp="26w8qg6kjr7i0">
              <MapPinIcon className="mt-0.5 h-5 w-5 shrink-0 text-gold" aria-hidden="true" data-id="element-271" data-mp="26v76fcljzao5" />
              <span data-id="element-272" data-mp="2km2gutbp9ztu">
                <span className="block font-semibold text-white" data-id="element-273" data-mp="2klkctaisqhbd">{business.name}</span>
                {business.street}
                <br data-id="element-274" data-mp="2go4pbjugj1na" />
                {business.plaza}
                <br data-id="element-275" data-mp="2uk8hz8pon1xn" />
                {business.city}, {business.region} {business.postalCode}
              </span>
            </p>
            <p className="flex gap-3" data-id="element-276" data-mp="2pkdpx1u686b0">
              <PhoneIcon className="mt-0.5 h-5 w-5 shrink-0 text-gold" aria-hidden="true" data-id="element-277" data-mp="1070gwzb45u3k" />
              <span data-id="element-278" data-mp="v8p90u4dptnz">
                <span className="sr-only" data-id="element-279" data-mp="v98nu1yqg1xs">{t(ui.contact.phoneLabel)}: </span>
                <a href={business.phoneHref} className="link-slide font-semibold text-gold" data-id="element-280" data-mp="2vayjeiv87y7g">{business.phoneDisplay}</a>
              </span>
            </p>
            <p className="flex gap-3" data-id="element-281" data-mp="30a1qe8uroei2">
              <MailIcon className="mt-0.5 h-5 w-5 shrink-0 text-gold" aria-hidden="true" data-id="element-282" data-mp="34bmy7fsg22le" />
              <span className="min-w-0" data-id="element-283" data-mp="39age1ev7e5oq">
                <span className="sr-only" data-id="element-284" data-mp="39bj5pp0coc5p">{t(ui.contact.emailLabel)}: </span>
                <a href={business.emailHref} className="link-slide break-all text-white hover:text-gold" data-id="element-285" data-mp="3ea2qvn74djx0">{business.email}</a>
              </span>
            </p>
            <p className="flex gap-3" data-id="element-286" data-mp="3j6jca9mxpk6e">
              <ClockIcon className="mt-0.5 h-5 w-5 shrink-0 text-gold" aria-hidden="true" data-id="element-287" data-mp="3nyug3nkspq48" />
              <span data-id="element-288" data-mp="3s1h93rt7dh30">
                <span className="sr-only" data-id="element-289" data-mp="3rzwg46mje679">{t(ui.contact.hoursLabel)}: </span>
                {t(ui.common.hours)}
              </span>
            </p>
          </address>

          <a href={business.mapsUrl} target="_blank" rel="noreferrer" className="btn-gold mt-8 lg:mt-auto" data-id="element-290" data-mp="5thnclx9bj1a">
            <NavigationIcon className="h-4 w-4" aria-hidden="true" data-id="element-291" data-mp="fy7k8ddszwyn" />
            {t(ui.contact.viewMap)}
          </a>
        </div>
      </div>
    </Reveal>;
}